export const UPDATE_TABLE_OF_OFFERS = "Aktualisiere den Table Of Offers";
export const RESET_TABLE_OF_OFFERS_STORE =
  "Entfernt alle Daten aus dem Table of Offers-Store";
